// redux/authSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  type: "real",
  id: 0,
  data: {},
  summaryData: { settlement_total: "", transaction_total: "" },
  error: null,
};

const bussinessSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setType(state, action) {
      state.type = action.payload;
    },
    setId(state, action) {
      state.id = action.payload;
    },
    setData(state, action) {
      ////console.log(action.payload,"action.playload")
      state.data = { ...action.payload };
    },
    setSummary(state, action) {
      state.summaryData = action.payload;
    },
    setError(state, action) {
      state.error = action.payload;
    },
  },
});

export const { setData, setSummary, setError, setType, setId } = bussinessSlice.actions;

export default bussinessSlice.reducer;
